import DistributaryForm from "../components/configuration/DistributaryZone/DistributoryZoneForm";

const DistributaryZoneFormPage = () => {
    return (
        <DistributaryForm />
    );
};      

export default DistributaryZoneFormPage;
